export const environment = {
    production: true,
    urls: {
        api: 'https://api.gsr.ae',
    },
    turnstileKey: '0x4AAAAAAAcd5wfzr1xdzuSi',
    tpl: {
        sentryDsn:
            'https://ff9ba495449e45aeaef359d2bd73be39@error.kalvad.com/20',
        sentryEnvironment: 'prod',
    },
};
